import { useTranslation } from 'react-i18next';

import { i18nNS } from '../../../../i18n';
import AttendanceIcon from '../../../../icons/AttendanceIcon';
import AttendanceWhiteIcon from '../../../../icons/AttendanceWhiteIcon';
import Tile from '../../../shared/Tile';
import AttendanceDrawer from '../AttendanceDrawer';
import useAttendanceTile from './vm';

const AttendanceTile = () => {
  const { t } = useTranslation([i18nNS.GLOSSARY]);

  const { isAttendanceDrawerOpen, handleCloseAttendanceDrawer, handleClick } = useAttendanceTile();

  return (
    <>
      <Tile
        icon={AttendanceWhiteIcon}
        hoverIcon={AttendanceIcon}
        title={t('attendance', { ns: i18nNS.GLOSSARY })}
        color="warning"
        onClick={handleClick}
        isActive={isAttendanceDrawerOpen}
      />
      <AttendanceDrawer open={isAttendanceDrawerOpen} onClose={handleCloseAttendanceDrawer} />
    </>
  );
};

export default AttendanceTile;
